<template>
<div class="photo-upload">
	<input type="file" ref="input" :accept="accept" multiple @change="onChange()">

	<div v-for="(file, index) in value" class="photo">
		<img :src="file.data" :alt="file.name">
		<a href="#" @click.prevent="remove(index)" class="remove">x</a>
	</div>
	<a href="#" @click.prevent="add" class="add">+</a>
	<div class="clear"></div>
</div>
</template>

<style>
.photo-upload input[type=file] {
	display: none;
}

.photo-upload .photo,
.photo-upload .add {
	float: left;
	position: relative;
	width: 40px;
	height: 40px;
	background: #aaa;
	margin: 8px 10px 0 0;
}

.photo-upload .photo img {
	width: 40px;
}

.photo-upload .photo .remove {
	position: absolute;
	top: -8px;
	right: -8px;
	background: black;
	color: white;
	border-radius: 20px;
	width: 16px;
	height: 16px;
	text-decoration: none;
	text-align: center;
	font-size: 10px;
	vertical-align: middle
}

.photo-upload .add {
	font-size: 20px;
	font-weight: bold;
	text-align: center;
	padding-top: 5px;
	box-sizing: border-box;
	color: #555;
	text-decoration: none;
}
</style>

<script>
export default {
	props: { 
		value: { type: Array, default: function () { return [ ] } }
	},
	data () {
		return { }
	},
	computed: {
		accept () {
			return 'image/jpeg,image/jpg,image/png,image/bmp,image/gif'
		}
	},
	methods: {
		add () {
			this.$refs.input.click();
		},
		remove (index) {
			this.value.splice(index, 1)
			this.$emit('input', this.value)
		},
		onChange () {
			const input = this.$refs.input

			if (input.files) {
				for (var i = 0; i < input.files.length; i++) {
					const file = {
						name: input.files[i].name,
						data: null
					}

					const reader = new FileReader()
					reader.onload = e => {
						file.data = e.target.result
					}
					reader.readAsDataURL(input.files[i]);

					this.value.push(file)
				}

				this.$emit('input', this.value)
			}
		}
	}
}
</script>


// WEBPACK FOOTER //
// photo-upload.vue?4e2389e7